export default "__VITE_ASSET__jPyQi4tA__"